import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lib-button',
  template: `
    <p>
      BUTTON WORKS!
    </p>
  `,
  styles: [],
})
export class ButtonComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
